import React from "react";
import { Modal } from "react-bootstrap";
import Resources from "../../types/Resources";
import TextInput from "../Common/TextInput";
import LabelCheckbox from "../Common/LabelCheckbox";
import { CompanyFormState } from "../../types/forms/CompanyFormState";
import LoadingSpinner from "../Common/LoadingSpinner";

export type CompanyFormModalProps = {
    formState: CompanyFormState;
    resources: Resources;
    show: boolean;
    modalHeader: string;
    canManageIsEnergyHarbourCustomer: boolean;
    isLoading: boolean;
    disableSubmit: boolean;
    onHide: () => void;
    onNameChange: (name: string) => void;
    onIsEnergyHarbourCustomerChange: (isChecked: boolean) => void;
    onSubmit: (e: React.FormEvent) => void;
};

function CompanyFormModal(props: CompanyFormModalProps) {
    const { resources } = props;

    return (
        <Modal show={props.show} onHide={props.onHide}>
            <Modal.Header closeButton>
                <Modal.Title>{props.modalHeader}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {props.isLoading ? (
                    <LoadingSpinner />
                ) : (
                    <form onSubmit={props.onSubmit}>
                        <TextInput
                            inputId="name-input"
                            labelText={resources.get("Name")}
                            onChange={props.onNameChange}
                            value={props.formState.name.value}
                            errorMessage={props.formState.name.errorMessage}
                            readOnly={false}
                            boldLabel={false}
                        />

                        <LabelCheckbox
                            checked={props.formState.isEnergyHarbourCustomer.value}
                            label={resources.get("IsEnergyHarbourCustomer")}
                            onChange={props.onIsEnergyHarbourCustomerChange}
                            id="is-energy-harbour-customer-checkbox"
                            tooltip={resources.get("IsEnergyHarbourCustomerTooltip")}
                            readOnly={!props.canManageIsEnergyHarbourCustomer}
                            containerClassName="mt-2"
                        />

                        <button type="submit" className="btn btn-primary mt-3 w-100" disabled={props.disableSubmit}>
                            {resources.get("Save")}
                        </button>
                    </form>
                )}
            </Modal.Body>
        </Modal>
    );
}

export default CompanyFormModal;
